import {
  Card,
  Typography,
  Button,
  List,
  message,
  Modal,
  Image,
  Upload,
  Spin,
} from "antd";
import React, { useState, useMemo, useContext, useEffect, useRef } from "react";
import AccountBindingModal from "./components/AccountBindingModal";
import UpdatePasswordModal from "./components/UpdatePasswordModal";
import WechatBindingModal from "./components/WechatBindingModal";
import { ReactComponent as CloseIcon } from "@/assets/icons/closeicon.svg";
import { LoadingOutlined, PlusOutlined } from "@ant-design/icons";
import {
  updateUserInfo,
  getUserInfo,
  getAuthComnonThirdList,
  imageUpload,
} from "@/services/api";
import { useOutletContext } from "react-router-dom";
import { connect } from "react-redux";
import actions from "@/redux/action";
import store from "../../../../redux/store";
import { context } from "../../index";
import "./index.less";
const { Paragraph } = Typography;

/**
 * 个人信息组件
 * @returns
 */
const PersonInfo = (props) => {
  const { getCurrentUserInfo, currentUserInfo, listLoading } =
    useOutletContext();
  /**
   * 微信是否绑定成功
   */
  const [wechatBindFlag, setWechatBindFlag] = useState(false);
  /**
   * 微信昵称
   */
  const [wechatNickName, setWechatNickName] = useState("");
  const [isMobile, setIsMobile] = useState(false);
  const [imageUrl, setImageUrl] = useState(
    "https://images.niuxuezhang.cn/imgs/account-center/user.svg"
  );
  /**
   * 微信绑定弹窗的ref对象
   */
  const wechatBindingModalRef = useRef();

  /**
   * 修改密码弹窗的ref对象
   */
  const updatePwdModalRef = useRef();

  /**
   * 账号绑定弹窗的ref对象
   */
  const accountBindingRef = useRef();

  useEffect(() => {
    getAuthThirdList();
    if (
      navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
    ) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  }, []);

  /**
   * 获取当前微信登录的状态(platform===1表示已绑定微信)
   */
  const getAuthThirdList = () => {
    getAuthComnonThirdList()
      .then((res) => {
        if (res.code === 200) {
          res?.data?.some((item) => item.platform === 1)
            ? setWechatBindFlag(true)
            : setWechatBindFlag(false);
          setWechatNickName(res?.data[0]?.nickname);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const dataSource = [
    {
      title: "微信",
      content: wechatBindFlag ? wechatNickName : "尚未绑定",
      btnSolt: (
        <>
          {!isMobile ? 
            wechatBindFlag ? (
              <Button
                className="btn btn-primary btn-sm"
                type="primary"
                key="wechatUnbind"
                onClick={() => {
                  wechatBindingModalRef?.current?.setModalVisible(
                    true,
                    wechatBindFlag,
                    currentUserInfo?.phone
                  );
                }}
              >
                解绑
              </Button>
            ) : (
              <Button
                className="btn btn-primary btn-sm"
                type="primary"
                key="wechatBind"
                onClick={() => {
                  wechatBindingModalRef?.current?.setModalVisible(true);
                }}
              >
                绑定
              </Button>
            )
           : ''}
        </>
      ),
    },
    {
      title: "手机号",
      content: currentUserInfo?.phone || "尚未绑定",
      btnSolt: (
        // <>
        //   {currentUserInfo?.phone ? (
        //     <Button
        //       className="btn btn-primary btn-sm"
        //       type="primary"
        //       key="phoneUnbind"
        //       onClick={() => {
        //         accountBindingRef?.current?.setModalVisible(true, 1, "update");
        //       }}
        //     >
        //       修改
        //     </Button>
        //   ) : (
        //     <Button
        //       className="btn btn-primary btn-sm"
        //       type="primary"
        //       key="phoneBind"
        //       onClick={() => {
        //         accountBindingRef?.current?.setModalVisible(true, 1, "bind");
        //       }}
        //     >
        //       绑定
        //     </Button>
        //   )}
        // </>
        <>
          {currentUserInfo?.phone === "" && (
            <Button
              className="btn btn-primary btn-sm"
              type="primary"
              key="phoneBind"
              onClick={() => {
                accountBindingRef?.current?.setModalVisible(true, 1, "bind");
              }}
            >
              绑定
            </Button>
          )}
        </>
      ),
    },
    {
      title: "登录密码",
      content: "************",
      btnSolt: (
        <Button
          className="btn btn-primary btn-sm"
          type="primary"
          key="add"
          onClick={() => {
            updatePwdModalRef?.current?.setModalVisible(
              true,
              currentUserInfo?.phone || ""
            );
          }}
        >
          修改
        </Button>
      ),
    },
    {
      title: "邮箱",
      content: currentUserInfo?.email || "尚未绑定",
      btnSolt: (
        <>
          {/* {currentUserInfo?.email ? (
            <Button
              className="btn btn-primary btn-sm"
              type="primary"
              key="emailUnbind"
              onClick={() => {
                accountBindingRef?.current?.setModalVisible(true, 2, "update");
              }}
            >
              修改
            </Button>
          ) : (
            <Button
              className="btn btn-primary btn-sm"
              type="primary"
              key="emailBind"
              onClick={() => {
                accountBindingRef?.current?.setModalVisible(true, 2, "bind");
              }}
            >
              绑定
            </Button>
          )} */}
          {(currentUserInfo?.email === "" || currentUserInfo?.email === null) && (
            <Button
              className="btn btn-primary btn-sm"
              type="primary"
              key="emailBind"
              onClick={() => {
                accountBindingRef?.current?.setModalVisible(true, 2, "bind");
              }}
            >
              绑定
            </Button>
          )}
        </>
      ),
    },
  ];

  return (
    <>
      <Card
        title="个人信息"
        extra={() => null}
        bordered={false}
        className="person_card w-100"
        headStyle={{ border: 0, fontWeight: 700, paddingBottom: 24 }}
      >
        <div
          className="text-center mb-4 user_avatar"
          style={{ width: "fitContent" }}
        >
          <div style={{ width: "64px" }} className="mx-auto">
            <Upload
              listType="picture-circle"
              maxCount={1}
              showUploadList={false}
              customRequest={async (options) => {
                let formData = new FormData();
                formData.append("file", options?.file);
                formData.append("type", "avatar");
                const { code, msg, data } = await imageUpload(formData);
                if (code === 200) {
                  setImageUrl(data?.url);
                  /**
                   * 更新用户头像
                   */
                  updateUserInfo({ head_pic: data?.url }).then((res) => {
                    if (res.code === 200) {
                      message.success("更新成功");
                      getCurrentUserInfo();
                    }
                  });
                } else {
                  message.error(msg);
                }
              }}
            >
              {imageUrl && (
                <img
                  src={currentUserInfo.head_pic || imageUrl}
                  alt="avatar"
                  style={{ borderRadius: '50%' }}
                  width={64}
                  height={64}
                />
              )}
            </Upload>
          </div>
          <Paragraph
            editable={{
              text: currentUserInfo?.nickname || '用户名字',
              tooltip: <span>修改昵称</span>,
              maxLength: 10,
              onChange: (value) => {
                //修改用户昵称
                updateUserInfo({ nickname: value }).then((res) => {
                  if (res.code === 200) {
                    message.success('更新成功');
                    getCurrentUserInfo();
                  }
                });
              },
            }}
            ellipsis={{
              suffix: currentUserInfo?.nickname || '用户名字',
            }}
          >
          </Paragraph>
        </div>
        <List
          dataSource={dataSource}
          rowKey="title"
          loading={listLoading}
          bordered={
            document.body.getAttribute("data-dev") === "mobile" ? false : true
          }
          className="person_list"
          renderItem={(item) => (
            <List.Item>
              <List.Item.Meta title={item.title} />
              <div className="content">{item.content}</div>
              {item.btnSolt}
            </List.Item>
          )}
        />
      </Card>
      {/* 微信绑定弹窗 */}
      <WechatBindingModal
        ref={wechatBindingModalRef}
        handlePhoneBind={() => {
          wechatBindingModalRef?.current?.setModalVisible(
            false,
            wechatBindFlag
          );
          accountBindingRef?.current?.setModalVisible(true, 1, "bind");
        }}
        handleReloadList={getCurrentUserInfo}
        handleReloadAuthThirdList={getAuthThirdList}
      />

      {/* 手机号/邮箱绑定弹窗 */}
      <AccountBindingModal
        ref={accountBindingRef}
        handleReloadList={getCurrentUserInfo}
      />

      {/* 修改密码弹窗 */}
      <UpdatePasswordModal
        ref={updatePwdModalRef}
        handlePhoneBind={() => {
          updatePwdModalRef?.current?.setModalVisible(false);
          accountBindingRef?.current?.setModalVisible(true, 1, "bind");
        }}
      />
    </>
  );
};

export default PersonInfo;
